import type React from "react"

import { Box } from "@mui/material"

interface StackedBarGraphSwatchProps {
  color: string
}

export const StackedBarGraphSwatch: React.FC<StackedBarGraphSwatchProps> = ({
  color,
}) => (
  <Box
    aria-hidden
    sx={(theme) => ({
      backgroundColor: color,
      borderRadius: theme.typography.pxToRem(2),
      flexShrink: 0,
      height: theme.typography.pxToRem(8),
      mr: theme.typography.pxToRem(2),
      width: theme.typography.pxToRem(8),
    })}
  />
)
